import React from "react"
import { ListViewItemStyle, ListViewStyle } from "./style"

export const ListView: React.FC<{
    top?: string,
    bottom?: string,
    height?: number,
    children: React.ReactNode
    itemShow?: boolean;
}> = ({ top: top, bottom: marginBottom, height, children, itemShow = true }) => (
    <ListViewStyle
        $marginTop={top}
        $marginBottom={marginBottom}
        $height={height}
    >
        {itemShow
            ? React.Children.map(children, (child, index) => (
                <ListViewItemStyle
                    key={
                        React.isValidElement(child) && child.key != null
                            ? String(child.key)
                            : index
                    }
                >
                    {child}
                </ListViewItemStyle>
            ))
            : children}
    </ListViewStyle>
)